import register from '../../util/init';
import {updateLinkState} from '../../util/link_state';
import {flickity} from '../../util/flickity';
import InfScr from '../../util/infscr';
import {enablePackery} from '../site';
import Packery from 'packery'; // docs https://packery.metafizzy.co/

function storiesIndex (container) {
  updateLinkState(document.querySelectorAll('nav.stories'));

  // gallery init
  container.querySelectorAll('.gallery').forEach((el) => {
    if (el.childElementCount > 1) {
      const flkty = flickity(el, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false
      });
    }
  });

  const allowCache = window.DEBUG ? false : true; // reverses true=false here
  const infscr = InfScr('.paginate', {
    contentSelector: '.page',
    nextSelector: '.next-page',
    autoOffset: 1500,
    allowCache: allowCache,
    beforeLoad: function () {
      // nothing here...
    },
    onLoad: function (newContent, container) {
      // possible add lazyload images?
      if (enablePackery) {
        document.querySelectorAll('.mosaic-layout').forEach((mosaicLayout) => {
          // initialise packery
          var pacMan = new Packery(mosaicLayout, {
            itemSelector: 'li'
          });
        })
      }
    }
  });

  // bind filter open/close
  container.querySelectorAll('nav.stories h2').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (trigger.parentElement.classList.contains('open')) {
        trigger.parentElement.classList.remove('open');
      } else {
        trigger.parentElement.classList.add('open');
      }
    });
  });

  return {
    resize: (w, h) => {
      infscr.resize(w, h);

    },
    scroll: (...args) => {
      infscr.scroll.apply(infscr, args);
    }
  };
}
register('stories-index', storiesIndex);



// WEBPACK FOOTER //
// ./assets/j/src/stories/index.js